/* Imports */
import CheckboxDropdown from './CheckboxDropdown';
import SelectDropdown from './SelectDropdown';

class Forms {
    constructor() {
        this.enhancedFields = new WeakSet();
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initForms(), { once: true });
        } else {
            this.initForms();
        }

        // Formie owns its runtime; enhance new controls after mounts and page changes.
        for (const event of ['formie:mount:after', 'formie:page:navigate:after', 'formie:submit:result']) {
            document.addEventListener(event, () => this.initForms());
        }
    }

    initForms() {
        for (const [selector, Dropdown] of [
            ['.checkbox-dropdowns [data-formie-field-type="checkboxes"]', CheckboxDropdown],
            ['.inquire-forms [data-formie-field-type="dropdown"]', SelectDropdown],
        ]) {
            document.querySelectorAll(selector).forEach((field) => {
                if (this.enhancedFields.has(field)) return;
                const dropdown = new Dropdown(field);
                if (dropdown.trigger) this.enhancedFields.add(field);
            });
        }
    }
}

export default new Forms();
